var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import { CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography, } from "@mui/material";
import { useAuth } from "../../hooks/useAuth";
import { obterFormularioRenach } from "../../services/habilitacao.service";
import { Colors } from "../../util/theme";
import { SnackbarFeedback } from "../SnackbarFeedback";
export var FormularioRenach = function (_a) {
    var isOpen = _a.isOpen, close = _a.close, renach = _a.renach;
    var userInfo = useAuth().userInfo;
    var _b = useState(isOpen), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = useState(), errormessage = _c[0], setErrorMessage = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(""), base64 = _e[0], setBase64 = _e[1];
    useEffect(function () {
        var getRenachForm = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setErrorMessage(undefined);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                            numeroRenach: renach,
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, obterFormularioRenach(payload)];
                    case 2:
                        response = _d.sent();
                        setBase64(response.pdf);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _d.sent();
                        setErrorMessage((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao gerar formulário renach");
                        setIsModalOpen(false);
                        setLoading(false);
                        close();
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        getRenachForm();
    }, [renach, close, userInfo]);
    return (_jsxs(_Fragment, { children: [_jsxs(Dialog, __assign({ open: isModalOpen, onClose: function () { return close(); }, fullWidth: true, maxWidth: base64 ? "xl" : "sm" }, { children: [_jsxs(DialogTitle, __assign({ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", gap: "1rem" }, { children: [_jsx(Stack, __assign({ bgcolor: Colors.AZUL_GOV, borderRadius: "50%", p: "0.5rem" }, { children: _jsx(TaskOutlinedIcon, { fontSize: "large", sx: { color: "white" } }) })), _jsx(Typography, __assign({ variant: "h6" }, { children: "Formul\u00E1rio Renach" }))] })), _jsx(IconButton, __assign({ onClick: function () {
                                    setIsModalOpen(false);
                                    close();
                                } }, { children: _jsx(CloseIcon, {}) }))] })), _jsx(DialogContent, { children: loading && !base64 ? (_jsx(Stack, __assign({ alignItems: "center", p: "4rem" }, { children: _jsx(CircularProgress, {}) }))) : (_jsx("iframe", { src: "data:application/pdf;base64,".concat(base64), width: "100%", height: "800px", style: { border: "none" }, title: "Formul\u00E1rio Renach" })) })] })), errormessage && (_jsx(SnackbarFeedback, { isOpen: !!errormessage, message: errormessage, type: "error" }))] }));
};
